import { render, staticRenderFns } from "./VueAudioSetUp.vue?vue&type=template&id=72a47e87&scoped=true&"
import script from "./VueAudioSetUp.vue?vue&type=script&lang=js&"
export * from "./VueAudioSetUp.vue?vue&type=script&lang=js&"
import style0 from "./VueAudioSetUp.vue?vue&type=style&index=0&lang=css&"
import style1 from "./VueAudioSetUp.vue?vue&type=style&index=1&id=72a47e87&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a47e87",
  null
  
)

export default component.exports